import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../services/apiClient";

function TeamReport() {
  const { teamId } = useParams();
  const [reportHtml, setReportHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        setLoading(true);
        setError(null);
        // Uses apiClient to send the Bearer Token
        const response = await apiClient.get(`/api/teams/${teamId}/report`, {
          responseType: 'text'
        });
        setReportHtml(response.data);
      } catch (err) {
        console.error('Failed to load O2 Team Report:', err);
        // Check for 403/401 status for a clearer message
        const message = err.response && (err.response.status === 403 || err.response.status === 401)
          ? 'Access denied to this team report. Please check your permissions.'
          : 'Failed to load Team Report. Check console for details.';
        setError(message);
      } finally {
        setLoading(false);
      }
    };

    if (teamId) fetchReport();
  }, [teamId]);

  const handleDownloadPDF = async () => {
    try {
      // Secure Blob Download with Bearer Token
      const response = await apiClient.get(`/api/teams/${teamId}/report/download`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      // Note: The filename is actually set by the Content-Disposition header in the server response
      link.setAttribute('download', `TeamReport_Team_${teamId}.pdf`); 
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed:', err);
      alert('Failed to download PDF. Check console for details.');
    }
  };

  if (loading) return <div className="p-8 text-center">Loading O2 Team Report...</div>;
  if (error) return <div className="p-8 text-red-600">{error}</div>;

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6 print:hidden">
        <h1 className="text-2xl font-bold">O2 Team Report (Team ID: {teamId})</h1>
        <button onClick={handleDownloadPDF} className="px-4 py-2 rounded-md bg-indigo-600 text-white hover:bg-indigo-700">
          Download PDF
        </button>
      </div>
      <div className="bg-white rounded-lg shadow-sm border p-6 overflow-auto">
        <div dangerouslySetInnerHTML={{ __html: reportHtml }} />
      </div>
    </div>
  );
}

export default TeamReport;